import Dialog from 'global/guides/Dialog'

interface IProps {
    open: boolean
    nome: string
    onOk: () => void
}

export function AvisoSegmentoPendente({ open, nome, onOk }: IProps) {
    return (
        <Dialog.Root
            width="fit"
            open={open}
            onSubmit={onOk}
            onClose={() => {}}
            disableEscapeKeyDown
        >
            <Dialog.Title wrap>
                É necessário informar o segmento de atuação de &quot;{nome}
                &quot; para continuar.
            </Dialog.Title>
            <Dialog.Actions>
                <Dialog.Actions.PrimaryButton closeOnSubmit>
                    Confirmar
                </Dialog.Actions.PrimaryButton>
            </Dialog.Actions>
        </Dialog.Root>
    )
}
